export const invoicesList = () => {
  return {
    status: 200,
    data: {
      invoiceList: [
        {
          invoiceType: 'STANDARD_TAX',
          noteType: null,
          invoiceReferenceNumber: 'EINV00001',
          uniqueReferenceIdentifier: '7d526a65-8599-4462-8418-7726ba2f89d2',
          issueDate: '2025-04-28 21:00:00',
          arabicBuyerName: 'Test',
          englishBuyerName: 'Test',
          grossTotalIncludingVat: 4884.0,
          invoiceStatus: 'SUBMITTED',
          submissionError: null,
          ticketNumber: null,
        },
      ],
      generatedThisYear: '1',
      generatedInvoices: '1',
      generatedNotes: '0',
      maxNumberPerPage: 50,
    },
  };
};

export const invoiceById = () => {
  return {
    status: 200,
    data: {
      invoiceTypeCode: 'STANDARD_TAX',
      invoiceTypeTransaction: '0100000',
      invoiceNumber: 'EINV00001',
      buyerInvoiceNumber: null,
      issueDate: '28-04-2025',
      supplyStartDate: '21-04-2025',
      supplyEndDate: '29-04-2025',
      invoiceStatus: 'SUBMITTED',
      noteType: null,
      reasonOfNote: null,
      originalInvoiceReference: '',
      arNotes: null,
      enNotes: null,
      qrCode:
        'ASQxYmE0N2Y2NC1mMzRmLTQ4ZWItYjNiNC1jYjEyMDhkMjAxMDUCAnt9AwVmYWxzZQQHNTYxNi42MAUJRUlOVjAwMDAxBgU3MzIuNgcKMjAyNS0wNC0yOQgPMzAwMDAwMDE3OTAwMDAzCR1Nb2hhbW1hZCBOYXNlci5Nb2hhbW1hZCBOYXNlcgoA',
      buyerDTO: {
        buyerEnglishName: 'Test',
        buyerArabicName: 'Test',
        buyerVatNumber: '',
        buyerGroupVatNumber: '',
        additionalBuyerIdType: 'NATIONAL_ID_NUMBER',
        additionalBuyerId: '123456789',
        buyerStreetEn: 'Shafa Badran',
        buyerStreetAr: 'Shafa Badran',
        additionalBuyerStreetEn: '',
        additionalBuyerStreetAr: '',
        buyerBuildingNumber: '',
        additionalBuyerBuildingNumber: '',
        buyerCity: '',
        buyerPostalCode: '00962',
        buyerStateEn: '',
        buyerStateAr: '',
        buyerNeighborhoodEn: '',
        buyerNeighborhoodAr: '',
        buyerCountryCode: 'AE',
      },
      sellerDTO: {
        vatNumber: '300000017900003',
        groupVatNumber: '',
        sellerEnglishName: 'Mohammad Naser',
        sellerArabicName: 'Mohammad Naser',
        additionalSellerIdType: 'CR',
        additionalSellerId: '123456',
        sellerStreetEn: 'Shafa Badran',
        sellerStreetAr: 'Shafa Badran',
        additionalSellerStreetEn: '',
        additionalSellerStreetAr: '',
        sellerBuildingNumber: '2222',
        additionalSellerBuildingNumber: '',
        sellerCity: 'ABU_DHABI',
        sellerPostalCode: '00962',
        sellerStateEn: 'Amman',
        sellerStateAr: 'Amman',
        sellerNeighborhoodEn: 'Amman',
        sellerNeighborhoodAr: 'Amman',
        sellerCountryCode: 'AE',
      },
      paymentTermsDTO: null,
      invoiceItems: [
        {
          descriptionAr: 'pen',
          descriptionEn: 'pen',
          unitPrice: 22.0,
          quantity: 222.0,
          subtotalAmount: 4884.0,
          discountAmount: 0.0,
          discountPercentage: 0.0,
          uuid: null,
          vatRateType: 'S',
          vatRate: 15.0,
          taxExemptionReason: null,
          vatAmount: 732.6,
          totalAmount: 5616.6,
        },
      ],
      xml: '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',
    },
  };
};

export const registeredSolution = () => {
  return {
    status: 200,
    data: {
      productionCertificateResponseList: [
        {
          commonName: 'TST-886431145-300000017900003',
          solutionSerialNumber:
            '1-TST|2-TST|3-ed22f1d8-e6a2-1118-9b58-d9a8f11e445f',
          vatNumber: '300000017900003',
          organizationUnitName: 'Riyadh Branch',
          organizationName: 'Maximum Speed Tech Supply LTD',
          countryName: 'SA',
          location: 'RRRD2929',
          industry: 'Supply activities',
          requestId: 17462219271708,
          status: 'ACTIVE',
          onBoardingDate: '2025-05-03T00:38:47.179',
          certifiedExpiryDate: '2026-05-03T00:38:47',
          revocationDate: null,
          smecertificate: false,
        },
        {
          commonName: 'TST-886431145-300000017900003',
          solutionSerialNumber: 'Test Serial Number',
          vatNumber: '300000017900003',
          organizationUnitName: 'Riyadh Branch',
          organizationName: 'Maximum Speed Tech Supply LTD',
          countryName: 'SA',
          location: 'RRRD2929',
          industry: 'Supply activities',
          requestId: 17462219271666,
          status: 'REVOKED',
          onBoardingDate: '2025-02-02T00:38:47.179',
          certifiedExpiryDate: '2026-05-30T00:38:47',
          revocationDate: null,
          smecertificate: false,
        },
      ],
    },
  };
};

export const certificationCounts = () => ({
  status: 200,
  data: {
    vat: '300000017900003',
    certificateValid: 1,
    certificateRevoked: 2,
    certificateExpired: 2,
  },
});

export const invoicesCounts = () => ({
  status: 200,
  data: {
    clearance: {
      warringInvoicesCount: 10,
      passedInvoicesCount: 50,
      errorInvoicesCount: 20,
    },
    reporting: {
      warringInvoicesCount: 2,
      passedInvoicesCount: 6,
      errorInvoicesCount: 3,
    },
  },
});

const generateOTPs = (num) => {
  const OTPs = [];
  for (let i = 0; i < num; i++) {
    OTPs.push(Math.floor(100000 + Math.random() * 900000).toString());
  }
  return OTPs;
};

export const OTPs = (num) => ({
  status: 200,
  data: {
    OTPs: generateOTPs(num),
  },
});

export const sellerInvoiceView = () => ({
  status: 200,
  data: [
    {
      invoiceNumber: 'EINV00001',
      invoiceIssueDate: '2023-03-18T21:00:00.000+00:00',
      invoiceIssueTime: null,
      invoiceTypeCode: 'STANDARD_CREDIT_NOTE',
      invoiceCurrencyCode: 'OMR',
      invoicedObjectIdentifier: null,
      processControl: null,
      businessProcessType: null,
      specificationIdentifier: null,
      precedingInvoiceReference: null,
      precedingInvoiceIssueDate: null,
      sellerName: 'Mohammad Ashour',
      sellerTaxIdentifier: '300000017900003',
      sellerElectronicAddress: 'DUBAI',
      sellerPostalAddress: '12542',
      buyerName: 'test',
      buyerTaxIdentifier: '312345678900003',
      buyerElectronicAddress: 'ABU_DHABI',
      buyerPostalAddress: '62526',
      sumOfInvoiceLineNetAmount: null,
      sumOfAllowancesOnDocumentLevel: null,
      sumOfChargesOnDocumentLevel: null,
      invoiceTotalAmountWithoutTax: 484.0,
      invoiceTotalTaxAmount: 43.13,
      invoiceTotalAmountWithTax: 484.0,
      paidAmount: 550.0,
      roundingAmount: 0.0,
      amountDueForPayment: 484.0,
      invoiceTotalTaxAmountInAccountingCurrency: null,
      taxBreakdowns: [
        {
          taxableAmount: 484.0,
          taxAmount: 43.13,
          taxCategoryCode: 'VAT',
          taxCategoryRate: 14.0,
        },
      ],
      invoiceLines: [
        {
          invoiceLineIdentifier: '3f51483c-3d03-4f8d-aadf-0cd7ad02e68d',
          invoicedQuantity: 22.0,
          invoicedQuantityUnitOfMeasureCode: 'PCS',
          invoiceLineNetAmount: 484.0,
          lineAllowances: 4.84,
          lineCharges: 0.0,
          itemNetPrice: 22.0,
          itemPriceBaseQuantity: 1.0,
          invoicedItemTaxCategoryCode: 'VAT',
          invoicedItemTaxRate: 9.0,
          itemName: 'www',
        },
      ],
    },
  ],
});

export const buyerInvoiceView = () => ({
  status: 200,
  data: [
    {
      invoiceNumber: 'EINV00002',
      invoiceIssueDate: '2023-03-18T21:00:00.000+00:00',
      invoiceIssueTime: null,
      invoiceTypeCode: 'STANDARD_CREDIT_NOTE',
      invoiceCurrencyCode: 'OMR',
      invoicedObjectIdentifier: null,
      processControl: null,
      businessProcessType: null,
      specificationIdentifier: null,
      precedingInvoiceReference: null,
      precedingInvoiceIssueDate: null,
      sellerName: 'Mohammad Ashour',
      sellerTaxIdentifier: '312345678900003',
      sellerElectronicAddress: 'DUBAI',
      sellerPostalAddress: '12542',
      buyerName: 'test',
      buyerTaxIdentifier: '300000017900003',
      buyerElectronicAddress: 'ABU_DHABI',
      buyerPostalAddress: '62526',
      sumOfInvoiceLineNetAmount: null,
      sumOfAllowancesOnDocumentLevel: null,
      sumOfChargesOnDocumentLevel: null,
      invoiceTotalAmountWithoutTax: 484.0,
      invoiceTotalTaxAmount: 43.13,
      invoiceTotalAmountWithTax: 484.0,
      paidAmount: 550.0,
      roundingAmount: 0.0,
      amountDueForPayment: 484.0,
      invoiceTotalTaxAmountInAccountingCurrency: null,
      taxBreakdowns: [
        {
          taxableAmount: 484.0,
          taxAmount: 43.13,
          taxCategoryCode: 'VAT',
          taxCategoryRate: 14.0,
        },
      ],
      invoiceLines: [
        {
          invoiceLineIdentifier: '3f51483c-3d03-4f8d-aadf-0cd7ad02e68d',
          invoicedQuantity: 22.0,
          invoicedQuantityUnitOfMeasureCode: 'PCS',
          invoiceLineNetAmount: 484.0,
          lineAllowances: 4.84,
          lineCharges: 0.0,
          itemNetPrice: 22.0,
          itemPriceBaseQuantity: 1.0,
          invoicedItemTaxCategoryCode: 'VAT',
          invoicedItemTaxRate: 9.0,
          itemName: 'www',
        },
      ],
    },
  ],
});
